import { ArrowUpRight } from "lucide-react";
import { Shell, Ctas, Credits, Note } from "../shared";
import { useRtl } from "../ReaderContext";

export const InterviewPage = ({ page }) => {
  const withImage = !!page.image;
  const rtl = useRtl();
  return (
    <Shell page={page}>
      {withImage && (
        <div className={`absolute inset-y-0 ${rtl ? "left-0" : "right-0"}`} style={{ width: 230 }}>
          <img src={page.image} alt={page.title} className="mag-img" style={page.image.includes("cover") ? { height: "125%", marginTop: -180, objectPosition: "60% 0%" } : { objectPosition: "50% 20%" }} />
          <div className="absolute inset-0" style={{ background: `linear-gradient(${rtl ? "270deg" : "90deg"}, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 22%)` }} />
        </div>
      )}
      <div className={`absolute ${rtl ? "right-11" : "left-11"}`} style={{ top: 64, bottom: 56, [rtl ? "left" : "right"]: withImage ? 250 : 44 }}>
        <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
        <h2 className="mag-head mt-2" style={{ fontSize: withImage ? 30 : 34 }}>{page.title}</h2>
        {page.deck && <p className="mag-deck mt-2" style={{ fontSize: 14.5, opacity: 0.85 }}>{page.deck}</p>}
        <div className="silver-rule-solid my-4" />
        <div className={`mag-body ${!withImage && page.qa.length > 3 ? "mag-cols" : ""}`}>
          {page.qa.map((x, i) => (
            <div key={i} className="mb-3" style={{ breakInside: "avoid" }}>
              <p className="font-head font-semibold" style={{ fontSize: 15.5, lineHeight: 1.2, color: "var(--bordeaux)" }}>{x.q}</p>
              <p style={{ marginTop: 3 }}>{x.a}</p>
            </div>
          ))}
        </div>
        {page.quote && (
          <div className="mt-4 pl-4" style={{ borderLeft: "2px solid var(--bordeaux)" }}>
            <p className="mag-quote" style={{ fontSize: 20 }}>“{page.quote}”</p>
            {page.quote_by && <p className="mag-kicker mt-1" style={{ fontSize: 8 }}>— {page.quote_by}</p>}
          </div>
        )}
        <Ctas page={page} className="mt-4" />
        <div className="absolute bottom-0 left-0 right-0">
          <Credits page={page} />
          <Note page={page} className="mt-1" />
        </div>
      </div>
    </Shell>
  );
};

export const ListPage = ({ page }) => (
  <Shell page={page}>
    <div className="absolute left-11 right-11" style={{ top: 64, bottom: 56 }}>
      <div className="mag-kicker" style={{ color: "var(--bordeaux)" }}>{page.kicker}</div>
      <h2 className="mag-head uppercase mt-2" style={{ fontSize: 40 }}>{page.title}</h2>
      {page.deck && <p className="mag-deck mt-1" style={{ opacity: 0.8 }}>{page.deck}</p>}
      <div className="mt-4">
        {page.items.map((it, i) => (
          <div key={i} className="flex gap-4 py-4" style={{ borderTop: "1px solid var(--platinum)" }} data-testid={`page-${page.n}-item-${i}`}>
            <div className="font-head" style={{ fontSize: 26, color: "var(--bordeaux)", width: 38, lineHeight: 1 }}>{String(i + 1).padStart(2, "0")}</div>
            <div className="flex-1">
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-head font-semibold" style={{ fontSize: 19, lineHeight: 1.05 }}>{it.title}</h3>
                {it.url && (
                  <a href={it.url} target="_blank" rel="noopener noreferrer" className="mag-kicker inline-flex items-center gap-1" style={{ color: "var(--bordeaux)", fontSize: 7.5, whiteSpace: "nowrap" }} data-testid={`page-${page.n}-link-${i}`}>
                    Link <ArrowUpRight size={9} />
                  </a>
                )}
              </div>
              <div className="mag-kicker mt-1" style={{ fontSize: 7.5, opacity: 0.6 }}>{it.meta}</div>
              <p className="mag-body mt-1" style={{ fontSize: 11.5 }}>{it.text}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-0 left-0 right-0">
        <Credits page={page} />
        <Note page={page} className="mt-1" />
      </div>
    </div>
  </Shell>
);
